import { SigningErrorContentType } from './signing-error-content-type.enum';
import { SigningErrorPagePath } from './signing-error-page-path.enum';

export const SIGNING_ERROR_PAGE_MAP: Record<SigningErrorContentType, SigningErrorPagePath> = {
  [SigningErrorContentType.NotFound]: SigningErrorPagePath.NotFound,
  [SigningErrorContentType.NoSuchApprover]: SigningErrorPagePath.NoSuchApprover,
  [SigningErrorContentType.NoAccessCpr]: SigningErrorPagePath.NoAccessCpr,
  [SigningErrorContentType.Archived]: SigningErrorPagePath.Archived,
  [SigningErrorContentType.AlreadySigned]: SigningErrorPagePath.AlreadySigned,
  [SigningErrorContentType.CprAlreadySigned]: SigningErrorPagePath.CprAlreadySigned,
  [SigningErrorContentType.VerifyError]: SigningErrorPagePath.VerifyError,
  [SigningErrorContentType.OrderMismatch]: SigningErrorPagePath.OrderMismatch,
  [SigningErrorContentType.PseudonymDisallowed]: SigningErrorPagePath.PseudonymDisallowed,
  [SigningErrorContentType.Unexpected]: SigningErrorPagePath.Unexpected,
  [SigningErrorContentType.Expired]: SigningErrorPagePath.Expired,
  [SigningErrorContentType.StepLocked]: SigningErrorPagePath.StepLocked,
  [SigningErrorContentType.StepNotAvailable]: SigningErrorPagePath.StepNotAvailable,
  [SigningErrorContentType.SigningCookieException]: SigningErrorPagePath.SigningCookieException,
  [SigningErrorContentType.SessionExpired]: SigningErrorPagePath.SessionExpired,
};
